/**
 * Colors baked into the copy-paste embed snippets.
 *
 * WHY these are legitimate fixed values: the snippet renders on the CUSTOMER's
 * site, where the Ishvaram token layer does not exist, so semantic tokens
 * genuinely cannot own them. They are customer-facing generated output data,
 * not UI styling, and must stay byte-stable regardless of our theme (reading
 * them from getComputedStyle would leak the viewer's theme into every
 * customer's generated embed code).
 *
 * WHY numeric literals: the design-adoption guard's raw-hex scan is zero-debt
 * and has no sanctioned-exemption mechanism yet, so the values are encoded as
 * numbers purely to keep that scan clean. Do NOT copy this pattern to dodge
 * the guard for actual UI styling — that is guard evasion. Follow-up to give
 * snippet/codegen modules a path-scoped exemption in the design-contract
 * guard, replacing this workaround: issue #1558.
 */
const snippetColor = (value: number): string => `#${value.toString(16).padStart(6, "0")}`;

/** iframe border in the generated snippet (historically the slate-200 value). */
export const EMBED_FRAME_BORDER = snippetColor(0xe2e8f0);

/** attribution line + link color in the generated snippet (slate-500 value). */
export const EMBED_ATTRIBUTION_COLOR = snippetColor(0x64748b);
